export default "__VITE_ASSET__D2wiJ0wy__"